<template>
    <div class="vendor-input">
        <input v-if="list.question_type === 'text'" type="text" style="width: 100%;" v-model="model" />
        <textarea v-if="list.question_type === 'textarea'" style="width: 100%;" v-model="model" />
        <div class="vendor-input flex-row" v-if="list.question_type === 'radio'">
            <div class="input-20">
                <input type="radio" name="ya" value="ya" v-model="model" />
                <label class="ml20" for="ya">Ya</label>
            </div>
            <div class="input-20">
                <input type="radio" name="tidak" value="tidak" v-model="model" />
                <label class="ml20" for="tidak">Tidak</label>
            </div>
        </div>
        <input v-if="list.question_type === 'date-picker'" type="date" style="width: 100%;" v-model="model"
            max="9999-12-31" />
        <input-date-range :modelStart="'form_value'" :modelEnd="'form_sub_value'" :list="list" :step="step" :i="i"
            :disabled="list.disabled" v-if="list.question_type === 'date-range'" />
        <md-upload v-if="list.question_type === 'attachment'" :step="step" :i="i" :list="list" :disabled="false" />
    </div>
</template>
<script>
export default {
    props: ['list', 'step', 'i', 'disabled'],
    components: {
        'md-upload': () => import('@/components/MasterDataLandingpage/md-upload.vue'),
    },
    computed: {
        model: {
            get() {
                const data = this.$get(this.$store, `state.landingpage.${this.step}.${this.i + 2}.form_value`, '')
                return data
            },
            set(newValue) {
                this.$store.commit('landingpage/MD_STEP_UPDATE', {
                    step: this.step,
                    name: 'form_value',
                    value: newValue,
                    index: this.i + 2
                })
            },
        },
    },
}
</script>